/**
 * 微信菜单模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取微信菜单列表
export const menuList = (params) => {
  return req.get('/wechat/menu/list', params);
}

// 新增微信菜单
export const menuAdd = (params) => {
  return req.post('/wechat/menu/add', params);
}

// 获取正式微信菜单列表
export const menuList1 = (params) => {
  return req.get('/wechat/menu/listDemo', params);
}

// 新增正式微信菜单
export const menuAdd1 = (params) => {
  return req.post('/wechat/menu/addDemo', params);
}